import {
    faFacebookSquare,
    faGithubSquare,
    faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelopeSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import myPic from "../../images/my-pic.png";
import Footer from "../Footer/Footer";
import Header from "../Home/Header/Header";
import "./About.css";

const About = () => {
    return (
        <div className="container">
            <Header></Header>
            <div className="row mt-5 pt-5 ms-3">
                <div className="col-md-6 about-me">
                    <img src={myPic} alt="" />
                    <div className="mt-5">
                        <h3>
                            <span className="title-color">I'm</span> Saurav
                            Ghosh
                        </h3>
                        <p>
                            I am a deep-heart javascript lover. I know some
                            front end and back end framework. Such as React Js,
                            Bootstrap, Node Js, Express Js and database mongoDB.
                            In a word MERN stack developer.
                        </p>
                    </div>
                    <div className="mt-5">
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.linkedin.com/in/saurav-ghosh-6a1ab0202/"
                        >
                            <FontAwesomeIcon
                                className="icon"
                                icon={faLinkedin}
                            />
                        </a>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://github.com/saurav-ghosh"
                        >
                            <FontAwesomeIcon
                                className="icon"
                                icon={faGithubSquare}
                            />
                        </a>
                        <Link to="/contact">
                            <FontAwesomeIcon
                                className="icon"
                                icon={faEnvelopeSquare}
                            />
                        </Link>
                        <FontAwesomeIcon
                            className="icon"
                            icon={faFacebookSquare}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div>
                        <h3 className="skills">Technical Skills</h3>
                        <div className="technology">
                            <span>Html5</span>
                            <span>Css3</span>
                            <span>Bootstrap4</span>
                            <span>Material UI</span>
                            <span>Javascript</span>
                            <span>React Js</span>
                            <span>Node Js</span>
                            <span>Express Js</span>
                            <span>MongoDB</span>
                            <span>Es6</span>
                            <span>Firebase</span>
                            <span>Netlify</span>
                            <span>Heroku</span>
                        </div>
                    </div>
                    <div className="mt-5">
                        <h3 className="skills">Familiar With</h3>
                        <div className="technology">
                            <span>Redux Js</span>
                            <span>Sass</span>
                            <span>Next Js</span>
                            <span>Typescript</span>
                            <span>React Native</span>
                            <span>Tailwind Css</span>
                            <span>Webpack</span>
                            <span>Agile methodology</span>
                        </div>
                    </div>
                    <div className="mt-5">
                        <h3 className="skills">Tools</h3>
                        <div className="technology">
                            <span>Vs Code</span>
                            <span>NodePad++</span>
                            <span>CodeBlocks</span>
                            <span>Sublime Text</span>
                            <span>Adobe PhotoShop</span>
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default About;
